<script setup lang="ts">
defineOptions({
  name: 'MapContainer',
})
</script>

<template>
  <div class="flex flex-col content-stretch justify-stretch h-full">
    <div class="relative h-full flex-1 flex overflow-hidden">
      <slot />
    </div>
  </div>
</template>
